// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Gs-z","tooltipWrapper":"Hs-z","icon":"Is-z","tooltip":"Js-z","content":"Ks-z"};